import { createTheme, ThemeOptions } from '@mui/material/styles';
import brand from '../../../brand.json';

/**
 * Tema MUI generado a partir de brand.json.
 * Para cambiar de cliente (white-label), solo editar brand.json.
 */
const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: brand.palette.primary,
    secondary: brand.palette.secondary,
    background: brand.palette.background,
    text: brand.palette.text,
    error: brand.palette.error,
    success: brand.palette.success,
    warning: brand.palette.warning,
    info: brand.palette.info,
  },
  typography: {
    fontFamily: brand.typography.fontFamily,
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
      defaultProps: { disableElevation: true },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500 },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 1 },
    },
  },
};

export const theme = createTheme(themeOptions);
export default theme;
